<template>
  <div>
    <NBar title="支付成功" :top="true" :on-click-home="home" :left-show="false" :right-show="false"/>
    <div class="pay-ok">
      <div class="pay-item">
        <template v-if="myData.payType == 1">
          <div class="item">
            <span class="title">启动设备</span>
            <span class="content">{{ orderData.deviceName }} {{ orderData.deviceId }}</span>
          </div>
          <div class="item">
            <span class="title">启动套餐</span>
            <span class="content">{{ orderData.totalMoney }}元 / {{ orderData.serviceTime }}分钟</span>
          </div>
          <div class="item" v-if="orderData.status == 0 && orderData.isRun == 0">
            <span class="title">开始时间</span>
            <span class="content">设备正在启动中...</span>
          </div>
          <div class="item" v-if="orderData.isRun == 1">
            <span class="title">开始时间</span>
            <span class="content">{{ orderData.payTime }}</span>
          </div>
          <div class="pay-line"></div>
          <template v-if="orderData.status == 0 && orderData.isRun == 1">
            <div class="pay-title">
              -剩余时间-
            </div>
            <div class="time">
              <span class="time-span">{{ hr }}</span>
              <span>:</span>
              <span class="time-span">{{ min }}</span>
              <span>:</span>
              <span class="time-span">{{ sec }}</span>
            </div>
          </template>
          <template v-else-if="orderData.status == 0 && orderData.isRun == 0">
            <div class="end-title" style="font-size: 12px;margin-top: 15px;">
              <span>设备如果长时间无法启动请联系商家</span>
            </div>
          </template>
          <template v-else>
            <div class="end-title">
              <span>服务结束</span>
            </div>
          </template>
        </template>
        <template v-if="myData.payType == 2">
          <div class="end-title">
            <span>支付成功</span>
          </div>
        </template>
        <template v-if="myData.payType == 3">
          <div class="end-title">
            <span>开通成功</span>
          </div>
        </template>
        <div class="btn-div">
          <nut-button v-if="myData.payType == 1 && orderData.status == 0 && orderData.isRun == 1"
                      style="border-radius: 7px;width: 50%;background: #409EFF;" @click="stop">强制结束
          </nut-button>
          <nut-button v-else-if="myData.payType == 1 && orderData.status == 0 && orderData.isRun == 0 && isRunNum < 0"
                      style="border-radius: 7px;width: 50%;background: #409EFF;" @click="stop">强制结束
          </nut-button>
          <nut-button v-if="myData.payType != 1 || orderData.status == 1"
                      style="border-radius: 7px;width: 50%;background: #409EFF;" @click="home">返回
          </nut-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayOk',
  props: ['data'],
  data() {
    return {
      //重试次数默认1次
      isRunNum: 1,
      orderData: {},
      timer: 0,
      hr: 0,
      min: 0,
      sec: 0,
      myData: {}
    }
  },
  mounted() {
    let loading = this.$toast.loading ('处理中...')
    if (!this.$util.isArrOrNull (this.data)) {
      let data = JSON.parse (decodeURIComponent (this.data))
      this.myData = data
    }
    if (this.myData.payType == 1) {
      setTimeout (() => {
        loading.hide()
        this.getOrderDetail ()
      }, 2000)
    }
  },
  methods: {
    home() {
      let deviceId = localStorage.getItem ('deviceId')
      this.$router.replace (`/device/DeviceUse?deviceId=${deviceId}`)
    },
    getOrderDetail() {
      this.$api.post ({
        url: '/device/api/device/order/detail',
        data: {
          merId: this.$api.merId,
          orderId: this.myData.orderId
        },
        loading: false
      }).then (res => {
        this.orderData = res.data
        if (this.orderData.status == 0) {
          if (this.orderData.isRun == 1) {//设备是否启动
            let date = this.$util.formatDate.format (new Date (), 'yyyy/MM/dd hh:mm:ss')
            let timeNow = new Date (date).getTime () / 1000
            this.orderData.endTime = new Date (this.orderData.endTime.replace (/-/g, '/')).getTime () / 1000
            this.orderData.totalSecond = (this.orderData.endTime - timeNow) * 1000
            clearTimeout (this.timer)
            this.countdown (this.orderData)
          } else {//处理设备启动问题
            this.isRunNum = this.isRunNum - 1
            if (this.isRunNum >= 0) {
              this.updateDevice ()
            }
          }
        } else {
          if (this.orderData.totalSecond > 0) {
            clearTimeout (this.timer)
            this.orderData.totalSecond = 0
          }
        }
      })
    },
    //更新设备和订单信息
    updateDevice() {
      setTimeout (() => {
        this.$api.post ({
          url: '/device/api/device/order/timeout-update',
          data: {
            id: this.orderData.id,
            isRun: 0
          },
          loading: false
        }).then (res => {
          setTimeout (() => this.getOrderDetail (), 1500)
        })
      }, 1500)
    },
    stop() {
      let that = this
      this.$dialog ({
        title: '确定强制结束？',
        content: '强制结束订单后机器将会停止,是否强制停止?',
        onOkBtn(event) {
          that.$api.post ({
            url: '/device/api/device/stop',
            data: {
              merId: that.$api.merId,
              uid: that.orderData.uid,
              orderId: that.myData.orderId,
              deviceId: that.orderData.deviceId
            }
          }).then (res => {
            that.getOrderDetail ()
            this.close ()
          })
        }
      })

    },
    //超时更新订单
    updateOrder() {
      this.$api.post ({
        url: '/device/api/device/order/timeout-update',
        data: {
          id: this.orderData.id
        },
        loading: false
      }).then (res => {
        this.orderData = res.data
        clearTimeout (this.timer)
        this.orderData.totalSecond = 0
      })
    },
    /* 毫秒级倒计时 */
    countdown: function (data) {
      if (data.totalSecond < 0) {
        this.updateOrder ()
        return
      } else {
        this.dateFormat (data.totalSecond)
      }
      data.totalSecond -= 1000
      let timer = setTimeout (res => {
        this.countdown (this.orderData)
      }, 1000)
      // 渲染倒计时时钟
      this.orderData = data
      this.timer = timer
    },
    // 时间格式化输出，如03:25:19 86。每10ms都会调用一次
    dateFormat: function (micro_second) {
      // 秒数
      let second = Math.floor (micro_second / 1000)
      // 小时位
      let hr = Math.floor (second / 3600)
      // 分钟位
      let min = Math.floor ((second - hr * 3600) / 60)
      // 秒位
      let sec = (second - hr * 3600 - min * 60)
      // 毫秒位，保留1位
      this.hr = hr
      this.min = min
      this.sec = sec
    },
  }
}
</script>

<style scoped>

.pay-ok {
  background: #fff;
  padding: 15px 30px;
}

.pay-item {
  border: 5px solid #409EFF;
  height: 200px;
  border-radius: 15px;
  padding: 10px 0;
}

.item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
}

.item .title {
  color: #9B9B9B;
  flex: 0.25;
}

.item .content {
  flex: 1;
}

.pay-line {
  border-bottom: 2px dashed #409EFF;
  margin-top: 10px;
}

.pay-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 10px;
  font-size: 13px;
}

.end-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 80px;
  line-height: 80px;
  font-size: 18px;
}

.time {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 10px 0 20px 0;
  font-size: 18px;
}

.time-span {
  width: 40px;
  height: 36px;
  line-height: 30px;
  background-color: #e5e5e5;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  margin: 0 10px;
}

.btn-div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/device/common/Pay/PayOk.vue